import { configureStore } from "@reduxjs/toolkit";

import apiSlice from "./apiSlice";
import authReducer from "../api/auth/authSlice";
import storeReducer from "../api/store/storeSlice";
import cartReducer from "./cartSlice";

const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    cart: cartReducer,
    data: storeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      apiSlice.middleware,
    ),
});

export default store;
